const au = [
  {
    label: 'ACT',
    value: 'act',
    children: [
      { label: 'Canberra', value: 'canberra' },
      { label: 'Oaks Estate', value: 'oaks-estate' },
    ],
  },
  {
    label: 'New South Wales',
    value: 'nsw',
    children: [
      { label: 'Sydney East', value: 'sydney-east' },
      { label: 'Sydney Metro', value: 'sydney-metro' },
      { label: 'Sydney North', value: 'sydney-north' },
      { label: 'Sydney South', value: 'sydney-south' },
      { label: 'Sydney West', value: 'sydney-west' },
      { label: 'Bathurst/Orange', value: 'bathurst+orange' },
      { label: 'Campbelltown/Camden', value: 'campbelltown+camden' },
      { label: 'Central Coast', value: 'central-coast' },
      { label: 'Central Eastern', value: 'central-eastern' },
      { label: 'Dubbo and Western Plains', value: 'dubbo-and-western-plains' },
      { label: 'Far North Coast', value: 'far-north-coast' },
      { label: 'Far West', value: 'far-west' },
      { label: 'Hunter/Newcastle', value: 'hunter+newcastle' },
      { label: 'Illawarra', value: 'illawarra' },
      { label: 'Jerrabomberra', value: 'jerrabomberra' },
      { label: 'Mid North Coast', value: 'mid-north-coast' },
      { label: 'North Coast', value: 'north-coast' },
      { label: 'North Eastern', value: 'north-eastern' },
      { label: 'North West', value: 'north-west' },
      { label: 'Northern Rivers', value: 'northern-rivers' },
      { label: 'Penrith & Blue Mts.', value: 'penrith+blue-mountains' },
      { label: 'Snowy Mountains', value: 'snowy-mountains' },
      { label: 'South Coast', value: 'south-coast' },
      { label: 'South Eastern', value: 'south-eastern' },
      { label: 'Southern Highlands', value: 'southern-highlands' },
      { label: 'Windsor/Richmond', value: 'windsor+richmond' },
    ],
  },
  {
    label: 'Northern Territory',
    value: 'nt',
    children: [
      { label: 'Alice Springs', value: 'alice-springs' },
      { label: 'Darwin', value: 'darwin' },
      { label: 'Katherine', value: 'katherine' },
    ],
  },
  {
    label: 'Queensland',
    value: 'qld',
    children: [
      { label: 'Brisbane All', value: 'brisbane-all' },
      { label: 'Brisbane East', value: 'brisbane-east' },
      { label: 'Brisbane North', value: 'brisbane-north' },
      { label: 'Brisbane South', value: 'brisbane-south' },
      { label: 'Brisbane West', value: 'brisbane-west' },
      { label: 'Bundaberg', value: 'bundaberg' },
      { label: 'Cairns', value: 'cairns' },
      { label: 'Capricorn', value: 'capricorn' },
      { label: 'Central', value: 'central' },
      { label: 'Darling Downs', value: 'darling-downs' },
      { label: 'Far North', value: 'far-north' },
      { label: 'Fraser Coast', value: 'fraser-coast' },
      { label: 'Gladstone', value: 'gladstone' },
      { label: 'Gold Coast', value: 'gold-coast' },
      { label: 'Mackay', value: 'mackay' },
      { label: 'North Brisbane', value: 'north-brisbane' },
      { label: 'Rockhampton', value: 'rockhampton' },
      { label: 'South East', value: 'south-east' },
      { label: 'South Western', value: 'south-western' },
      { label: 'Sunshine Coast', value: 'sunshine-coast' },
      { label: 'Townsville', value: 'townsville' },
      { label: 'Whitsundays', value: 'whitsundays' },
      { label: 'Wide Bay Burnett', value: 'wide-bay-burnett' },
    ],
  },
  {
    label: 'South Australia',
    value: 'sa',
    children: [
      { label: 'Adelaide', value: 'adelaide' },
      { label: 'Adelaide Eastern', value: 'adelaide-eastern' },
      { label: 'Adelaide Nouth-East', value: 'adelaide-north-east' },
      { label: 'Adelaide Northern', value: 'adelaide-northern' },
      { label: 'Adelaide Southern', value: 'adelaide-southern' },
      { label: 'Adelaide Western', value: 'adelaide-western' },
      { label: 'Barossa', value: 'barossa' },
      { label: 'Country Central', value: 'country-central' },
      { label: 'Country North', value: 'country-north' },
      { label: 'Eyre Peninsula', value: 'eyre-peninsula' },
      { label: 'Mid North', value: 'mid-north' },
      { label: 'South East', value: 'south-east' },
      { label: 'The Riverland', value: 'the-riverland' },
    ],
  },
  {
    label: 'Tasmania',
    value: 'tas',
    children: [
      { label: 'North West', value: 'north-west' },
      { label: 'North/North East', value: 'north+north-east' },
      { label: 'South', value: 'south' },
    ],
  },
  {
    label: 'Victoria',
    value: 'vic',
    children: [
      { label: 'Melbourne CBD', value: 'melbourne-cbd' },
      { label: 'Melbourne North', value: 'melbourne-north' },
      { label: 'Melbourne East', value: 'melbourne-east' },
      { label: 'Melbourne South', value: 'melbourne-south' },
      { label: 'Melbourne West', value: 'melbourne-west' },
      { label: 'Ballarat Districts', value: 'ballarat-districts' },
      { label: 'Country Victoria', value: 'country-victoria' },
      { label: 'East Gippsland', value: 'east-gippsland' },
      { label: 'Geelong Districts', value: 'geelong-districts' },
      { label: 'Gippsland', value: 'gippsland' },
      { label: 'Mornington Peninsula', value: 'mornington-peninsula' },
      { label: 'North Central', value: 'north-central' },
      { label: 'North East', value: 'north-east' },
      { label: 'Seymour District', value: 'seymour-district' },
      { label: 'Warrnambool', value: 'warrnambool' },
      { label: 'Western Districts', value: 'western-districts' },
      { label: 'Wimmera', value: 'wimmera' },
      { label: 'Wimmera Mallee', value: 'wimmera-mallee' },
    ],
  },
  {
    label: 'Western Australia',
    value: 'wa',
    children: [
      { label: 'North West', value: 'north-west' },
      { label: 'Perth', value: 'perth' },
      { label: 'Pilbara/Kimberley', value: 'pilbara+kimberley' },
      { label: 'South West', value: 'south-west' },
    ],
  },
];

const uk = [
  {
    label: 'England',
    value: 'england',
    children: [
      { label: 'London', value: 'london' },
      { label: 'East Central London', value: 'east-central-london' },
      { label: 'East London', value: 'east-london' },
      { label: 'North London', value: 'north-london' },
      { label: 'North West London', value: 'north-west-london' },
      { label: 'South East London', value: 'south-east-london' },
      { label: 'South West London', value: 'south-west-london' },
      { label: 'West Central London', value: 'west-central-london' },
      { label: 'West London', value: 'west-london' },
      { label: 'Bedfordshire', value: 'bedfordshire' },
      { label: 'Berkshire', value: 'berkshire' },
      { label: 'Bristol', value: 'bristol' },
      { label: 'Buckinghamshire', value: 'buckinghamshire' },
      { label: 'Cambridgeshire', value: 'cambridgeshire' },
      { label: 'Cheshire', value: 'cheshire' },
      { label: 'Cornwall', value: 'cornwall' },
      { label: 'Cumbria', value: 'cumbria' },
      { label: 'Derbyshire', value: 'derbyshire' },
      { label: 'Devon', value: 'devon' },
      { label: 'Dorset', value: 'dorset' },
      { label: 'Durham', value: 'durham' },
      { label: 'East Riding of Yorkshire', value: 'east-riding-of-yorkshire' },
      { label: 'East Sussex', value: 'east-sussex' },
      { label: 'Essex', value: 'essex' },
      { label: 'Gloucestershire', value: 'gloucestershire' },
      { label: 'Guernsey', value: 'guernsey' },
      { label: 'Hampshire', value: 'hampshire' },
      { label: 'Herefordshire', value: 'herefordshire' },
      { label: 'Hertfordshire', value: 'hertfordshire' },
      { label: 'Isle of Man', value: 'isle-of-man' },
      { label: 'Isle of Wight', value: 'isle-of-wight' },
      { label: 'Isles of Scilly', value: 'isles-of-scilly' },
      { label: 'Jersey', value: 'jersey' },
      { label: 'Kent', value: 'kent' },
      { label: 'Lancashire', value: 'lancashire' },
      { label: 'Leicestershire', value: 'leicestershire' },
      { label: 'Lincolnshire', value: 'lincolnshire' },
      { label: 'Manchester', value: 'manchester' },
      { label: 'Merseyside', value: 'merseyside' },
      { label: 'Middlesex', value: 'middlesex' },
      { label: 'Norfolk', value: 'norfolk' },
      { label: 'North Yorkshire', value: 'north-yorkshire' },
      { label: 'Northamptonshire', value: 'northamptonshire' },
      { label: 'Northumberland', value: 'northumberland' },
      { label: 'Nottinghamshire', value: 'nottinghamshire' },
      { label: 'Oxfordshire', value: 'oxfordshire' },
      { label: 'Rutland', value: 'rutland' },
      { label: 'Shropshire', value: 'shropshire' },
      { label: 'Somerset', value: 'somerset' },
      { label: 'South Yorkshire', value: 'south-yorkshire' },
      { label: 'Staffordshire', value: 'staffordshire' },
      { label: 'Suffolk', value: 'suffolk' },
      { label: 'Surrey', value: 'surrey' },
      { label: 'Tyne & Wear', value: 'tyne+wear' },
      { label: 'Warwickshire', value: 'warwickshire' },
      { label: 'West Midlands', value: 'west-midlands' },
      { label: 'West Sussex', value: 'west-sussex' },
      { label: 'West Yorkshire', value: 'west-yorkshire' },
      { label: 'Wiltshire', value: 'wiltshire' },
      { label: 'Worcestershire', value: 'worcestershire' },
    ],
  },
  {
    label: 'Northern Ireland',
    value: 'northern-ireland',
    children: [
      { label: 'Co Antrim', value: 'co-antrim' },
      { label: 'Co Armagh', value: 'co-armagh' },
      { label: 'Co Down', value: 'co-down' },
      { label: 'Co Fermanagh', value: 'co-fermanagh' },
      { label: 'Co Londonderry', value: 'co-londonderry' },
      { label: 'Co Tyrone', value: 'co-tyrone' },
    ],
  },
  {
    label: 'Scotland',
    value: 'scotland',
    children: [
      { label: 'Aberdeen & Deeside', value: 'aberdeen+deeside' },
      { label: 'Argyll', value: 'argyll' },
      { label: 'Ayrshire & Clyde Valley', value: 'ayrshire+clyde-valley' },
      { label: 'Dumfries & Galloway', value: 'dumfries+galloway' },
      { label: 'Edinburgh', value: 'edinburgh' },
      { label: 'Fife & Angus', value: 'fife+angus' },
      { label: 'Glasgow', value: 'glasgow' },
      { label: 'Highlands & Islands', value: 'highlands+islands' },
      { label: 'Scottish Borders', value: 'scottish-borders' },
      { label: 'Stirling', value: 'stirling' },
      { label: 'Tayside', value: 'tayside' },
      { label: 'The Lothians', value: 'the-lothians' },
    ],
  },
  {
    label: 'Wales',
    value: 'wales',
    children: [
      { label: 'Bridgend', value: 'bridgend' },
      { label: 'Caerphilly', value: 'caerphilly' },
      { label: 'Cardiff', value: 'cardiff' },
      { label: 'Carmarthenshire', value: 'carmarthenshire' },
      { label: 'Ceredigion', value: 'ceredigion' },
      { label: 'Conwy', value: 'conwy' },
      { label: 'Denbighshire', value: 'denbighshire' },
      { label: 'Flintshire', value: 'flintshire' },
      { label: 'Gwynedd', value: 'gwynedd' },
      { label: 'Isle of Anglesey', value: 'isle-of-anglesey' },
      { label: 'Merthyr Tydfil', value: 'merthyr-tydfil' },
      { label: 'Mid Glamorgan', value: 'mid-glamorgan' },
      { label: 'Monmouthshire', value: 'monmouthshire' },
      { label: 'Neath Port Talbot', value: 'neath-port-talbot' },
      { label: 'Newport', value: 'newport' },
      { label: 'North Wales', value: 'north-wales' },
      { label: 'Pembrokeshire', value: 'pembrokeshire' },
      { label: 'Powys', value: 'powys' },
      { label: 'Swansea', value: 'swansea' },
      { label: 'Torfaen', value: 'torfaen' },
      { label: 'Vale Of Glamorgan', value: 'vale-of-glamorgan' },
      { label: 'Wrexham', value: 'wrexham' },
    ],
  },
];

export const countryMap = {
  uk: 'United Kingdom',
  au: 'Australia',
};

export default {
  au: au,
  uk: uk,
};
